import { IRootState } from '../../../store'
import { IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'

export const getStateCustomDisplayDataSelector = (state: IRootState): IStateCustomDataDisplayState =>
  state.customDisplayData
